import React, { Fragment, memo } from "react";
import { Rate } from "antd";

const DynamicDataFilteration = ({
  selectedCheckbox,
  filterData,
}) => {
 

  return (
    <Fragment>
      <div className="col-lg-12 col-12">
        <div className="slider-restaurent">
          {/* Advertisement */}
          <div className="adver-sec">
            <a href="https://www.anrdoezrs.net/click-8265264-15520591" target="_top">
              <img loading="lazy" src="https://www.lduhtrp.net/image-8265264-15520591" width="728" height="90" alt="" border="0" />
            </a>
          </div>
          <div className="slider-main">
            <div className="slider-heading">
              <h3>{`${selectedCheckbox}`}</h3>
            </div>         
            <div id="ProductSlide-audio">
              {/* Map through filterData to generate carousel items */}
              {filterData &&
                filterData.map((ele, index) => {
                  return (
                    <a href={ele.url} key={index} target="_blank" rel="noreferrer">
                      <div className="slider-block">                   
                          <img loading="lazy" src={ele.image_url} alt="images" />                   
                        <div className="slider-content ">
                          <h3><a>
                            {ele?.name.length >= 18 ? `${ele.name.slice(0, 18)}...` : ele?.name}
                          </a>
                          </h3>
                          <div className="restro_btns">
                            <div className="restro_deals">
                              <a className="restro_btn">VIEW DEAL</a>
                              <a className="restro_btn">ORDER ONLINE</a>
                            </div>

                            <div className="star">
                              <ul>
                                <li>
                                  <Rate allowHalf defaultValue={ele.rating} disabled />
                                  <p>({ele.review_count} Reviews)</p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                      </div>
                    </a>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

// Memoize the component to prevent unnecessary re-renders
export default memo(DynamicDataFilteration);
